import { createApi } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';
import { fetchQuery } from './helpers/fetchQuery';

export const websiteAccountApi = createApi({
  reducerPath: 'websiteAccountApi',
  tagTypes: ['AccountEntitlements'],
  baseQuery: fetchQuery({ basePath: '/v1', subDomain: 'websites.accounts.api' }),
  extractRehydrationInfo(action, { reducerPath }): any {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  endpoints: builder => ({})
});
